import { render, staticRenderFns } from "./tabs-body.vue?vue&type=template&id=65947cba&"
import script from "./tabs-body.vue?vue&type=script&lang=js&"
export * from "./tabs-body.vue?vue&type=script&lang=js&"
import style0 from "./tabs-body.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabs-body.vue"
export default component.exports